(function () {
    'use strict';

    angular.module("imApp").factory("purchPriceUpdateService", ['$ihttp', function ($ihttp) {
        var service = {
            getPurchasePriceUpdate: function (parms) {
                return $ihttp.post({
                    method: 2086,
                    parameters: parms || {}
                });
            },
            saveGrid: function (mergeObj) {
                return $ihttp.post({
                    method: 2088,
                    parameters: mergeObj
                });
            }
        };

        return service;
    }]);
})();